import axios from "axios";
import { requiredParam } from "@utils/func";

const getInvoice = ({ invoiceId = requiredParam("invoiceId") } = {}) => {
  return axios.get(`invoices/${invoiceId}`);
};

const patchInvoice = ({
  invoiceId = requiredParam("invoiceId"),
  data = requiredParam("data"),
} = {}) => {
  return axios.patch(`invoices/${invoiceId}`, data);
};

const getCompanyInvoices = ({
  companyId = requiredParam("companyId"),
} = {}) => {
  return axios.get(`companies/${companyId}/invoices`);
};

export { getInvoice, patchInvoice, getCompanyInvoices };
